export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  const ATTR_LAYER = 'data-event-layer';
  const ATTR_KEY = 'data-event-key';
  const ATTR_VALUE = 'data-event-value';

  /**
   * Click handler.
   * 
   * @param {Element} element 
   * @returns 
   */
  const clickHandler = (element) => {
    const el = $(element);
    const elLayer = el.closest(`[${ATTR_LAYER}]`);
    const elLayerValue = elLayer.length ? (elLayer.attr(ATTR_LAYER) || '').trim() : '';

    // cancel if the clicked element is not a descendent of [data-event-layer] element or
    //   [data-event-layer] attribute value is missing.
    if (!elLayer || !elLayerValue ) {
      return;
    }

    // traverse up
    const elParents = el.parentsUntil(elLayer);

    let trackData = {
      'event': elLayerValue
    };

    // counter
    let c = 0;

    // temporary variables to hold data-event-key and data-event-value attributes value.
    let tmpKey = '';
    let tmpValue = '';

    for (let i = 0; i < elParents.length; i++) {
      const p = elParents.eq(i);
      const k = (p.attr(ATTR_KEY) || '').trim();
      const v = (p.attr(ATTR_VALUE) || '').trim();

      // wrong implemantation
      if ((tmpValue && v) || (tmpKey && k)) {
        tmpValue = tmpKey = '';
      }
      // wrong implemantion
      else if (!tmpValue && k) {
        tmpValue = tmpKey = '';
      }
      // find a valid data-event-value first
      else if (!tmpValue && v) {
        tmpValue = v;
      }
      // if we have a value, find the key
      else if (tmpValue && !tmpKey && k) {
        tmpKey = k;
      }

      if (tmpValue && tmpKey) {
        c++;
        trackData[tmpKey] = tmpValue;
        tmpValue = tmpKey = '';
      }
    }

    // only push to datalayer if we have at least one data besides the 'event'
    if (c > 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(trackData);
    }
  };

  return () => {
    $(() => {
      $(window.document).on('click', `[${ATTR_LAYER}] a`, (ev) => {
        clickHandler(ev.currentTarget);
      });

      // ------------------------------------------------
      // ----- data layer on sc form submit success -----
      //
      // @DEV NOTE: Use window.jQuery because we must reference to jQuery from Sitecore Form
      if (typeof window.jQuery !== 'undefined') {
        // global hook into ajaxSend to check if it is an sc form submission.
        window.jQuery(window.document).on('ajaxSend', (event, jqxhr, settings) => {
          // console.log('ajaxSend fired');
          
          if (settings.url.match(/\/formbuilder/)) {
            // patch the converters to intercept text script response from server.
            if (typeof settings.converters !== 'undefined' && typeof settings.converters['text script'] !== 'undefined' && typeof settings.converters['text script org'] === 'undefined') {
              // parse submit URL to get Form ID, find the form element and get the Form Type
              var objUrl = new URL(settings.url);
              var params = objUrl.searchParams;
              var formId = params.get('fxb.FormItemId');
              //var formPrefix = params.get('fxb.HtmlPrefix');
              var frm = $('form[id$="_'+formId+'"]');
            
              // if the form is found and it has form type
              if (frm && frm.length && frm.attr('data-form-type')) {
                // backup original text script converter handler
                settings.converters['text script org'] = settings.converters['text script'];
                // new text script converter handler
                settings.converters['text script'] = function(text) {
                  //debugger;
                  // check if it is a redirect submit action
                  if (text.match(/window\.location\s*=/)) {
                    // delay redirect submit action
                    window.__aggScFormRedirects = window.__aggScFormRedirects || {};
                    window.__aggScFormRedirects[formId] = {
                      orgHandler: settings.converters['text script org'],
                      orgText: text,
                      formType: frm.attr('data-form-type')
                    };
                  }
                  else {
                    // call original
                    settings.converters['text script org'].call(window, text);
                  }
                };
              }
            }
          }
        });

        // all forms with Form Type are customized to fire `sc-forms-submit-success` event
        window.document.addEventListener('sc-forms-submit-success', (ev) => {
          if (ev && ev.detail && ev.detail.formId) {
            // get the form ID
            let formId = ev.detail.formId.toLowerCase().replace(/^\{+/, '').replace(/\}$/, '');

            // if this form ID has redirect submit action delayed
            if (formId && typeof window.__aggScFormRedirects !== 'undefined' && typeof window.__aggScFormRedirects[formId] !== 'undefined') {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event' : 'formSubmission',
                'formType' : window.__aggScFormRedirects[formId]['formType']
              });

              window.__aggScFormRedirects[formId]['orgHandler'].call(window, window.__aggScFormRedirects[formId]['orgText']);
            }
            // either this form doesn't have redirect submit action delayed or
            // server returns HTML which can contain server side error message or other content.
            else {
              // check if the HTML is a form and contains server side error
              //
              
              // find the form
              let elForm = window.document.querySelector(`form[id$=_${formId}]`);
              // find form error message (server side validation) element
              let elErrors = elForm ? elForm.querySelector(`:scope .validation-summary-errors`) : null;
              // get form type
              let formType = elForm ? elForm.getAttribute('data-form-type') || '' : '';
              // get error message
              let txtErrors = null;

              if (elErrors) {
                txtErrors = (elErrors.textContent || '').trim();
              }

              // if not error and form type defined
              if (!txtErrors && formType) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  'event' : 'formSubmission',
                  'formType' : formType
                });
              }
            }
          }
        });
      }
      // --
    });
  };
})(jQuery, window);
